import { TransferState, inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ApiService } from './services/api/api.service';
import { map, of } from 'rxjs';

export const hostelsByCityResolver: ResolveFn<any> = (route, state) => {
  const ssrData = inject(TransferState);

  if (ssrData?.['HOSTELS_BY_CITY']) {
    return of(ssrData['HOSTELS_BY_CITY'].data);
  }
  return inject(ApiService)
    .getHostelsByCity(route.paramMap.get('slug')!)
    .pipe(
      map((resp) => {
        return resp.data;
      })
    );
};
